// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Zp-z","imageAndVideoCount":"_p-z","imageAndVideoContainer":"aq-z","viewAllReviews":"bq-z"};